/**
 * Pre-computed test scenarios from the solver.
 * Generated by: npx tsx src/testSolver.ts
 *
 * Each scenario contains a seed, draw count, and an array of TestActions
 * that the TestRunner replays to exercise every interaction type and verify
 * the game reaches a winning state.
 */

import type { TestAction } from './testSolver'

interface TestScenario {
    name: string
    seed: number
    drawCount: 1 | 3
    handedness?: 'left' | 'right'
    actions: TestAction[]
}

/**
 * Draw-1, Seed 1: 207 actions (200 game moves + undo test + auto-complete + win check)
 * Foundation moves alternate between doubleTap and drag-to-foundation to exercise both code paths.
 */
const draw1Scenario: TestScenario = {
    name: 'Draw-1 Seed 1',
    seed: 1,
    drawCount: 1,
    actions: [
        {
            type: 'assert',
            condition: 'state.stock.length === 24',
            description: 'Stock should have 24 cards after deal',
        },
        {
            type: 'assert',
            condition: 'state.waste.length === 0',
            description: 'Waste should be empty after deal',
        },
        { type: 'drag', cardId: '8H', target: 'tableau6' },
        { type: 'drag', cardId: '6H', target: 'tableau0' },
        { type: 'drag', cardId: 'JH', target: 'tableau5' },
        { type: 'drag', cardId: '5D', target: 'tableau3' },
        { type: 'drag', cardId: '7S', target: 'tableau6' },
        { type: 'tapUndo' },
        { type: 'assert', condition: 'true', description: 'Undo reversed last move' },
        { type: 'drag', cardId: '7S', target: 'tableau6' },
        { type: 'drag', cardId: '2S', target: 'tableau2' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '4S', target: 'tableau3' },
        { type: 'drag', cardId: '3H', target: 'tableau3' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'doubleTap', cardId: 'AH' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'AS', target: 'foundation0' },
        { type: 'doubleTap', cardId: '2S' },
        { type: 'drag', cardId: '3S', target: 'foundation0' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'doubleTap', cardId: '2H' },
        { type: 'drag', cardId: '3H', target: 'foundation1' },
        { type: 'doubleTap', cardId: '4S' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '4H', target: 'foundation1' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'doubleTap', cardId: '5S' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '6S', target: 'foundation0' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '7C', target: 'tableau4' },
        { type: 'drag', cardId: '6H', target: 'tableau4' },
        { type: 'doubleTap', cardId: '7S' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '8S', target: 'foundation0' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'KD', target: 'tableau1' },
        { type: 'drag', cardId: 'QS', target: 'tableau1' },
        { type: 'drag', cardId: '9S', target: 'tableau5' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '10C', target: 'tableau1' },
        { type: 'drag', cardId: '9D', target: 'tableau1' },
        { type: 'drag', cardId: '8C', target: 'tableau1' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '7D', target: 'tableau1' },
        { type: 'drag', cardId: '6C', target: 'tableau1' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'JC', target: 'tableau3' },
        { type: 'drag', cardId: '10D', target: 'tableau3' },
        { type: 'drag', cardId: 'JS', target: 'tableau6' },
        { type: 'drag', cardId: '5C', target: 'tableau4' },
        { type: 'doubleTap', cardId: 'AC' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '10H', target: 'tableau6' },
        { type: 'drag', cardId: '9C', target: 'tableau6' },
        { type: 'drag', cardId: '8D', target: 'tableau6' },
        { type: 'drag', cardId: '5H', target: 'foundation1' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'QC', target: 'tableau5' },
        { type: 'drag', cardId: 'JD', target: 'tableau5' },
        { type: 'drag', cardId: '4C', target: 'tableau1' },
        { type: 'drag', cardId: 'KC', target: 'tableau0' },
        { type: 'drag', cardId: 'QH', target: 'tableau0' },
        { type: 'drag', cardId: '5C', target: 'tableau6' },
        { type: 'doubleTap', cardId: '6H' },
        { type: 'drag', cardId: '6D', target: 'tableau0' },
        { type: 'drag', cardId: '4D', target: 'tableau0' },
        { type: 'drag', cardId: '2C', target: 'foundation2' },
        { type: 'doubleTap', cardId: '7H' },
        { type: 'drag', cardId: '8H', target: 'foundation1' },
        { type: 'doubleTap', cardId: '9S' },
        { type: 'drag', cardId: '10S', target: 'foundation0' },
        { type: 'tapStock' },
        { type: 'doubleTap', cardId: '9H' },
        { type: 'drag', cardId: '9C', target: 'tableau3' },
        { type: 'drag', cardId: '10H', target: 'foundation1' },
        { type: 'doubleTap', cardId: 'JS' },
        { type: 'drag', cardId: '10C', target: 'tableau5' },
        { type: 'drag', cardId: 'JH', target: 'foundation1' },
        { type: 'doubleTap', cardId: 'QH' },
        { type: 'drag', cardId: 'QS', target: 'foundation0' },
        { type: 'drag', cardId: 'QD', target: 'tableau0' },
        { type: 'doubleTap', cardId: '3C' },
        { type: 'drag', cardId: 'AD', target: 'foundation3' },
        { type: 'doubleTap', cardId: '4C' },
        { type: 'drag', cardId: 'QC', target: 'tableau1' },
        { type: 'drag', cardId: 'KH', target: 'foundation1' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'doubleTap', cardId: '2D' },
        { type: 'drag', cardId: '3D', target: 'foundation3' },
        { type: 'doubleTap', cardId: '4D' },
        { type: 'drag', cardId: '5C', target: 'foundation2' },
        { type: 'doubleTap', cardId: '5D' },
        { type: 'drag', cardId: '6D', target: 'foundation3' },
        { type: 'doubleTap', cardId: '6C' },
        { type: 'drag', cardId: '7C', target: 'foundation2' },
        { type: 'doubleTap', cardId: '7D' },
        { type: 'drag', cardId: '8D', target: 'foundation3' },
        { type: 'doubleTap', cardId: '8C' },
        { type: 'drag', cardId: '9C', target: 'foundation2' },
        { type: 'doubleTap', cardId: '9D' },
        { type: 'drag', cardId: '10D', target: 'foundation3' },
        { type: 'doubleTap', cardId: '10C' },
        { type: 'drag', cardId: 'JC', target: 'foundation2' },
        { type: 'doubleTap', cardId: 'JD' },
        { type: 'drag', cardId: 'QD', target: 'foundation3' },
        { type: 'doubleTap', cardId: 'QC' },
        { type: 'drag', cardId: 'KC', target: 'foundation2' },
        { type: 'doubleTap', cardId: 'KD' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'KS', target: 'foundation0' },
        { type: 'tapAutoComplete' },
        { type: 'waitForWin' },
    ],
}

/**
 * Draw-3, Seed 1: 117 actions (110 game moves + undo test + auto-complete + win check)
 * Foundation moves alternate between doubleTap and drag-to-foundation to exercise both code paths.
 */
const draw3Scenario: TestScenario = {
    name: 'Draw-3 Seed 1',
    seed: 1,
    drawCount: 3,
    actions: [
        {
            type: 'assert',
            condition: 'state.stock.length === 24',
            description: 'Stock should have 24 cards after deal',
        },
        {
            type: 'assert',
            condition: 'state.waste.length === 0',
            description: 'Waste should be empty after deal',
        },
        { type: 'drag', cardId: '8H', target: 'tableau6' },
        { type: 'drag', cardId: '6H', target: 'tableau0' },
        { type: 'drag', cardId: 'JH', target: 'tableau5' },
        { type: 'drag', cardId: '5D', target: 'tableau3' },
        { type: 'drag', cardId: '7S', target: 'tableau6' },
        { type: 'tapUndo' },
        { type: 'assert', condition: 'true', description: 'Undo reversed last move' },
        { type: 'drag', cardId: '7S', target: 'tableau6' },
        { type: 'drag', cardId: '2S', target: 'tableau2' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '4C', target: 'tableau3' },
        { type: 'drag', cardId: '3H', target: 'tableau3' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '10C', target: 'tableau2' },
        { type: 'drag', cardId: '2D', target: 'tableau4' },
        { type: 'doubleTap', cardId: 'AS' },
        { type: 'drag', cardId: '2S', target: 'foundation0' },
        { type: 'drag', cardId: '9D', target: 'tableau2' },
        { type: 'doubleTap', cardId: 'AH' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '2H', target: 'foundation3' },
        { type: 'doubleTap', cardId: '3H' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '4H', target: 'foundation3' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'KD', target: 'tableau0' },
        { type: 'drag', cardId: 'QS', target: 'tableau0' },
        { type: 'drag', cardId: '9S', target: 'tableau5' },
        { type: 'drag', cardId: '8C', target: 'tableau2' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'JC', target: 'tableau6' },
        { type: 'drag', cardId: '10D', target: 'tableau6' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '7D', target: 'tableau2' },
        { type: 'drag', cardId: '6C', target: 'tableau2' },
        { type: 'drag', cardId: 'JS', target: 'tableau3' },
        { type: 'drag', cardId: '5C', target: 'tableau6' },
        { type: 'doubleTap', cardId: 'AC' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '10S', target: 'tableau0' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '9H', target: 'tableau0' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'QC', target: 'tableau5' },
        { type: 'drag', cardId: 'JD', target: 'tableau5' },
        { type: 'drag', cardId: 'KC', target: 'tableau2' },
        { type: 'drag', cardId: 'QD', target: 'tableau2' },
        { type: 'drag', cardId: '2D', target: 'tableau3' },
        { type: 'drag', cardId: '3S', target: 'foundation0' },
        { type: 'doubleTap', cardId: '4S' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '5S', target: 'foundation0' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'doubleTap', cardId: '6S' },
        { type: 'drag', cardId: '10H', target: 'tableau2' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'drag', cardId: '9C', target: 'tableau2' },
        { type: 'drag', cardId: '8D', target: 'tableau2' },
        { type: 'drag', cardId: '5H', target: 'foundation3' },
        { type: 'drag', cardId: '3D', target: 'tableau5' },
        { type: 'drag', cardId: '7C', target: 'tableau2' },
        { type: 'drag', cardId: '6H', target: 'tableau2' },
        { type: 'doubleTap', cardId: '7S' },
        { type: 'tapStock' },
        { type: 'drag', cardId: 'KS', target: 'tableau1' },
        { type: 'drag', cardId: '8S', target: 'foundation0' },
        { type: 'drag', cardId: 'QH', target: 'tableau1' },
        { type: 'drag', cardId: '5C', target: 'tableau6' },
        { type: 'doubleTap', cardId: '6H' },
        { type: 'drag', cardId: '6D', target: 'tableau2' },
        { type: 'drag', cardId: '3C', target: 'tableau6' },
        { type: 'drag', cardId: 'AD', target: 'foundation2' },
        { type: 'doubleTap', cardId: '2D' },
        { type: 'drag', cardId: '3D', target: 'foundation2' },
        { type: 'drag', cardId: '4D', target: 'tableau2' },
        { type: 'doubleTap', cardId: '2C' },
        { type: 'tapAutoComplete' },
        { type: 'waitForWin' },
    ],
}

/**
 * UI Settings Test — exercises all menu/settings interactions.
 *
 * This test opens the menu, toggles every setting, verifies each change takes
 * effect, then restores defaults. It also tests the new game button and undo
 * button in a non-solving context.
 *
 * Seed 1, draw-1 (default) — the specific deal doesn't matter, we just need
 * a game on screen to interact with the UI elements.
 */
const uiSettingsScenario: TestScenario = {
    name: 'UI Settings',
    seed: 1,
    drawCount: 1,
    actions: [
        // ── 1. Verify initial state ──
        { type: 'assertAppState', expected: 'Playing', description: 'Game should start in Playing state' },
        { type: 'assertSetting', key: 'drawCount', expected: 1, description: 'Default draw count is 1' },
        {
            type: 'assertSetting',
            key: 'handedness',
            expected: 'right',
            description: 'Default handedness is right',
        },
        {
            type: 'assertSetting',
            key: 'cardBackDesign',
            expected: 'pattern',
            description: 'Default card back is pattern',
        },

        // ── 2. Test menu open/close ──
        { type: 'tapMenuButton' },
        { type: 'assertAppState', expected: 'Menu', description: 'Menu should be open after tap' },
        { type: 'tapMenuButton' },
        { type: 'assertAppState', expected: 'Playing', description: 'Menu should close after second tap' },

        // ── 3. Test draw count toggle ──
        // Changing draw count closes the menu and starts a new game
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'draw-3' },
        {
            type: 'assertSetting',
            key: 'drawCount',
            expected: 3,
            description: 'Draw count should be 3 after tapping draw-3',
        },
        {
            type: 'assertAppState',
            expected: 'Playing',
            description: 'Menu should close after draw count change',
        },
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'draw-1' },
        {
            type: 'assertSetting',
            key: 'drawCount',
            expected: 1,
            description: 'Draw count should be 1 after tapping draw-1',
        },
        {
            type: 'assertAppState',
            expected: 'Playing',
            description: 'Menu should close after draw count change',
        },

        // ── 4. Test handedness toggle ──
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'hand-left' },
        {
            type: 'assertSetting',
            key: 'handedness',
            expected: 'left',
            description: 'Handedness should be left after tapping hand-left',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'hand-right' },
        {
            type: 'assertSetting',
            key: 'handedness',
            expected: 'right',
            description: 'Handedness should be right after tapping hand-right',
        },

        // ── 5. Test card back toggle ──
        { type: 'tapMenuHitArea', hitAreaId: 'back-solid' },
        {
            type: 'assertSetting',
            key: 'cardBackDesign',
            expected: 'solid',
            description: 'Card back should be solid after tapping back-solid',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'back-pattern' },
        {
            type: 'assertSetting',
            key: 'cardBackDesign',
            expected: 'pattern',
            description: 'Card back should be pattern after tapping back-pattern',
        },

        // ── 6a. Test haptics toggle ──

        { type: 'tapMenuHitArea', hitAreaId: 'haptic-off' },
        {
            type: 'assertSetting',
            key: 'hapticsEnabled',
            expected: false,
            description: 'Haptics should be disabled after tapping haptic-off',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'haptic-on' },
        {
            type: 'assertSetting',
            key: 'hapticsEnabled',
            expected: true,
            description: 'Haptics should be enabled after tapping haptic-on',
        },

        // ── 6b. Test sound toggle ──

        { type: 'tapMenuHitArea', hitAreaId: 'sound-off' },
        {
            type: 'assertSetting',
            key: 'soundEnabled',
            expected: false,
            description: 'Sound should be disabled after tapping sound-off',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'sound-on' },
        {
            type: 'assertSetting',
            key: 'soundEnabled',
            expected: true,
            description: 'Sound should be enabled after tapping sound-on',
        },

        // ── 6. Test ALL 6 themes with color verification ──
        // Navigate to Themes sub-screen first
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },

        // Theme 1: HighContrastTheme
        { type: 'tapMenuHitArea', hitAreaId: 'theme-HighContrastTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'HighContrastTheme',
            description: 'Theme should be HighContrastTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === 'black'",
            description: 'HighContrastTheme backgroundColor should be black',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.cardBackColor === '#2A2A3A'",
            description: 'HighContrastTheme cardBackColor should be #2A2A3A',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.cardFaceColor === '#E8E8E8'",
            description: 'HighContrastTheme cardFaceColor should be #E8E8E8 (not white)',
        },

        // Theme 2: ClassicGreenTheme
        { type: 'tapMenuHitArea', hitAreaId: 'theme-ClassicGreenTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'ClassicGreenTheme',
            description: 'Theme should be ClassicGreenTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#1B5E20'",
            description: 'ClassicGreenTheme backgroundColor should be #1B5E20',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.cardBackColor === '#6B1C2A'",
            description: 'ClassicGreenTheme cardBackColor should be #6B1C2A',
        },

        // Theme 3: PleasedPinkTheme
        { type: 'tapMenuHitArea', hitAreaId: 'theme-PleasedPinkTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'PleasedPinkTheme',
            description: 'Theme should be PleasedPinkTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#C12849'",
            description: 'PleasedPinkTheme backgroundColor should be #C12849',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.cardBackColor === '#8B2040'",
            description: 'PleasedPinkTheme cardBackColor should be #8B2040',
        },

        // Theme 4: SoftBlueTheme
        { type: 'tapMenuHitArea', hitAreaId: 'theme-SoftBlueTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'SoftBlueTheme',
            description: 'Theme should be SoftBlueTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#268bd2'",
            description: 'SoftBlueTheme backgroundColor should be #268bd2',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.cardBackColor === '#1A3A5C'",
            description: 'SoftBlueTheme cardBackColor should be #1A3A5C',
        },

        // Theme 5: HappyPurpleTheme
        { type: 'tapMenuHitArea', hitAreaId: 'theme-HappyPurpleTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'HappyPurpleTheme',
            description: 'Theme should be HappyPurpleTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#292D3E'",
            description: 'HappyPurpleTheme backgroundColor should be #292D3E',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.cardBackColor === '#5E35A0'",
            description: 'HappyPurpleTheme cardBackColor should be #5E35A0',
        },

        // Theme 6: ForestTheme
        { type: 'tapMenuHitArea', hitAreaId: 'theme-ForestTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'ForestTheme',
            description: 'Theme should be ForestTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#33402E'",
            description: 'ForestTheme backgroundColor should be #33402E',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.cardBackColor === '#6B3A28'",
            description: 'ForestTheme cardBackColor should be #6B3A28',
        },

        // Restore default theme (HighContrastTheme is the initial default)
        { type: 'tapMenuHitArea', hitAreaId: 'theme-HighContrastTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'HighContrastTheme',
            description: 'Theme should be restored to HighContrastTheme',
        },
        // Navigate back to main menu from Themes sub-screen
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },

        // ── 7. Close menu and test undo ──
        { type: 'tapMenuButton' },
        { type: 'assertAppState', expected: 'Playing', description: 'Back to Playing after closing menu' },

        // Make a move (tap stock to draw a card), then undo it
        { type: 'tapStock' },
        {
            type: 'assert',
            condition: 'state.waste.length > 0',
            description: 'Waste should have cards after drawing from stock',
        },
        { type: 'tapUndo' },
        {
            type: 'assert',
            condition: 'state.waste.length === 0',
            description: 'Waste should be empty after undoing stock draw',
        },

        // ── 8. Test new game button (now lives inside the menu) ──
        // First draw a card so state is dirty
        { type: 'tapStock' },
        // Open the menu, then tap new game button
        { type: 'tapMenuButton' },
        {
            type: 'assertAppState',
            expected: 'Menu',
            description: 'Menu should be open before tapping New Game',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'new-game' },
        // After new game, stock should be full (24 cards) and waste empty
        {
            type: 'assert',
            condition: 'state.stock.length === 24',
            description: 'Stock should have 24 cards after new game',
        },
        {
            type: 'assert',
            condition: 'state.waste.length === 0',
            description: 'Waste should be empty after new game',
        },
        {
            type: 'assertAppState',
            expected: 'Playing',
            description: 'Should be in Playing state after new game',
        },
    ],
}

/**
 * Draw-1 Left-Handed: Reuses draw1Scenario's action sequence with left-handed layout.
 * Same seed, same moves — validates that left-handed coordinate mirroring works correctly.
 * The test runner resolves card positions by cardId at runtime, so the same solve
 * sequence exercises the mirrored coordinate system end-to-end.
 */
const draw1lhScenario: TestScenario = {
    name: 'Draw-1 Seed 1 (Left-Handed)',
    seed: draw1Scenario.seed,
    drawCount: draw1Scenario.drawCount,
    handedness: 'left',
    actions: draw1Scenario.actions,
}

/**
 * Draw-3 Left-Handed: Reuses draw3Scenario's action sequence with left-handed layout.
 * Same seed, same moves — validates that left-handed coordinate mirroring works correctly.
 */
const draw3lhScenario: TestScenario = {
    name: 'Draw-3 Seed 1 (Left-Handed)',
    seed: draw3Scenario.seed,
    drawCount: draw3Scenario.drawCount,
    handedness: 'left',
    actions: draw3Scenario.actions,
}

/**
 * Theme Smoke Test: Opens menu, switches through all 6 themes, and for each:
 * - Verifies theme is applied (backgroundColor, cardBackColor)
 * - Closes menu, plays a few stock taps + undo to exercise rendering
 * - Re-opens menu for next theme
 *
 * Uses seed 1 draw-1 for a consistent initial deal.
 * This catches rendering regressions where a theme's colors aren't applied correctly.
 */
const themesSmokeScenario: TestScenario = {
    name: 'Theme Smoke Test',
    seed: 1,
    drawCount: 1,
    actions: [
        // Verify initial deal
        {
            type: 'assert',
            condition: 'state.stock.length === 24',
            description: 'Stock should have 24 cards after deal',
        },

        // ── Theme 1: HighContrastTheme ──
        { type: 'tapMenuButton' },
        { type: 'assertAppState', expected: 'Menu', description: 'Menu should be open' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-HighContrastTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'HighContrastTheme',
            description: 'Theme should be HighContrastTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === 'black'",
            description: 'HighContrastTheme bg should be black',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuButton' },
        { type: 'assertAppState', expected: 'Playing', description: 'Back to playing' },
        // Play a few moves to exercise rendering with this theme
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapUndo' },
        { type: 'tapUndo' },

        // ── Theme 2: ClassicGreenTheme ──
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-ClassicGreenTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'ClassicGreenTheme',
            description: 'Theme should be ClassicGreenTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#1B5E20'",
            description: 'ClassicGreenTheme bg should be #1B5E20',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuButton' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapUndo' },
        { type: 'tapUndo' },

        // ── Theme 3: PleasedPinkTheme ──
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-PleasedPinkTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'PleasedPinkTheme',
            description: 'Theme should be PleasedPinkTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#C12849'",
            description: 'PleasedPinkTheme bg should be #C12849',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuButton' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapUndo' },
        { type: 'tapUndo' },

        // ── Theme 4: SoftBlueTheme ──
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-SoftBlueTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'SoftBlueTheme',
            description: 'Theme should be SoftBlueTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#268bd2'",
            description: 'SoftBlueTheme bg should be #268bd2',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuButton' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapUndo' },
        { type: 'tapUndo' },

        // ── Theme 5: HappyPurpleTheme ──
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-HappyPurpleTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'HappyPurpleTheme',
            description: 'Theme should be HappyPurpleTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#292D3E'",
            description: 'HappyPurpleTheme bg should be #292D3E',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuButton' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapUndo' },
        { type: 'tapUndo' },

        // ── Theme 6: ForestTheme ──
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-ForestTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'ForestTheme',
            description: 'Theme should be ForestTheme',
        },
        {
            type: 'assert',
            condition: "appState.currentTheme.backgroundColor === '#33402E'",
            description: 'ForestTheme bg should be #33402E',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuButton' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapUndo' },
        { type: 'tapUndo' },

        // ── Restore default theme ──
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-HighContrastTheme' },
        {
            type: 'assertSetting',
            key: 'themeName',
            expected: 'HighContrastTheme',
            description: 'Theme restored to default HighContrastTheme',
        },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuButton' },
        { type: 'assertAppState', expected: 'Playing', description: 'Back to playing after theme test' },

        // Final state check — game should still be intact
        {
            type: 'assert',
            condition: 'state.stock.length === 24',
            description: 'Stock still has 24 cards (all moves were undone)',
        },
        {
            type: 'assert',
            condition: 'state.waste.length === 0',
            description: 'Waste is empty (all moves were undone)',
        },
    ],
}

/**
 * Return all actions up to (but excluding) the first tapAutoComplete action.
 * Useful for manual verification runs where we want the game staged right
 * before auto-complete and let the user tap it themselves.
 */
function actionsBeforeAutoComplete(actions: TestAction[]): TestAction[] {
    const autoIndex = actions.findIndex((action) => action.type === 'tapAutoComplete')
    if (autoIndex === -1) return actions.slice()
    return actions.slice(0, autoIndex)
}

/** Return the first N actions from a scenario action list. */
function takeActions(actions: TestAction[], count: number): TestAction[] {
    return actions.slice(0, Math.max(0, count))
}

/**
 * Manual setup scenario: replays Draw-1 to the point where auto-complete is available,
 * then stops so the user can tap the auto-complete button manually.
 */
const draw1setupScenario: TestScenario = {
    name: 'Draw-1 Pre Auto-Complete (Manual Setup)',
    seed: draw1Scenario.seed,
    drawCount: draw1Scenario.drawCount,
    actions: actionsBeforeAutoComplete(draw1Scenario.actions),
}

/**
 * Manual setup scenario: replays Draw-3 to the point where auto-complete is available,
 * then stops so the user can tap the auto-complete button manually.
 */
const draw3setupScenario: TestScenario = {
    name: 'Draw-3 Pre Auto-Complete (Manual Setup)',
    seed: draw3Scenario.seed,
    drawCount: draw3Scenario.drawCount,
    actions: actionsBeforeAutoComplete(draw3Scenario.actions),
}

/**
 * Screenshot scenario: mid-game board in default Twilight theme.
 * Uses the opening portion of Draw-1 to create visible progress quickly.
 */
const screenshotGameplayScenario: TestScenario = {
    name: 'Screenshot - Gameplay Midgame',
    seed: draw1Scenario.seed,
    drawCount: draw1Scenario.drawCount,
    actions: takeActions(draw1Scenario.actions, 40),
}

/**
 * Screenshot scenario: menu open with theme controls visible.
 */
const screenshotMenuScenario: TestScenario = {
    name: 'Screenshot - Menu Open',
    seed: 1,
    drawCount: 1,
    actions: [
        {
            type: 'assert',
            condition: 'state.stock.length === 24',
            description: 'Stock should have 24 cards after deal',
        },
        { type: 'tapMenuButton' },
        { type: 'assertAppState', expected: 'Menu', description: 'Menu should be open for screenshot' },
    ],
}

/**
 * Screenshot scenario: left-handed Classic theme in Draw-3 with visible waste.
 */
const screenshotClassicLeftScenario: TestScenario = {
    name: 'Screenshot - Classic Left Handed',
    seed: 1,
    drawCount: 1,
    actions: [
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-ClassicGreenTheme' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuHitArea', hitAreaId: 'hand-left' },
        { type: 'tapMenuHitArea', hitAreaId: 'draw-3' },
        {
            type: 'assertAppState',
            expected: 'Playing',
            description: 'Draw mode change should return to playing state',
        },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        {
            type: 'assert',
            condition: 'state.waste.length > 0',
            description: 'Waste should be visible for gameplay screenshot',
        },
    ],
}

/**
 * Screenshot scenario: Ocean theme, right-handed, Draw-3 gameplay state.
 */
const screenshotOceanRightScenario: TestScenario = {
    name: 'Screenshot - Ocean Right Handed',
    seed: 1,
    drawCount: 1,
    actions: [
        { type: 'tapMenuButton' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-themes' },
        { type: 'tapMenuHitArea', hitAreaId: 'theme-SoftBlueTheme' },
        { type: 'tapMenuHitArea', hitAreaId: 'menu-back' },
        { type: 'tapMenuHitArea', hitAreaId: 'hand-right' },
        { type: 'tapMenuHitArea', hitAreaId: 'draw-3' },
        {
            type: 'assertAppState',
            expected: 'Playing',
            description: 'Draw mode change should return to playing state',
        },
        { type: 'tapStock' },
        { type: 'tapStock' },
        { type: 'tapStock' },
        {
            type: 'assert',
            condition: 'state.waste.length > 0',
            description: 'Waste should be visible for gameplay screenshot',
        },
    ],
}

/**
 * Screenshot scenario: completed win screen.
 *
 * Instead of replaying the full draw3 scenario (~120 actions that can fail
 * silently in the native simulator), this directly seeds a won-game state
 * with all 52 cards in foundations. Completes in milliseconds and is 100% reliable.
 */
const screenshotWinScenario: TestScenario = {
    name: 'Screenshot - Win State',
    seed: 1,
    drawCount: 1,
    actions: [
        { type: 'seedWinState' },
        { type: 'assertAppState', expected: 'Completed', description: 'Win state should be active' },
    ],
}

/** All available test scenarios, keyed by URL param value. */
export const testScenarios: Record<string, TestScenario> = {
    draw1: draw1Scenario,
    draw1lh: draw1lhScenario,
    draw3: draw3Scenario,
    draw3lh: draw3lhScenario,
    draw1setup: draw1setupScenario,
    draw3setup: draw3setupScenario,
    'shot-gameplay': screenshotGameplayScenario,
    'shot-menu': screenshotMenuScenario,
    'shot-classic-left': screenshotClassicLeftScenario,
    'shot-ocean-right': screenshotOceanRightScenario,
    'shot-win': screenshotWinScenario,
    ui: uiSettingsScenario,
    themes: themesSmokeScenario,
}
